import { render, staticRenderFns } from "./SignLayoutComponent.vue?vue&type=template&id=0b28b1eb&"
import script from "./SignLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./SignLayoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports